import ListFilterType from 'www/modules/Filters/ListFilterType'

const DEFAULT_REGION = {
  name: 'Любые',
  value: 'any',
  data: {
    regionType: '',
    townRedirectTranslit: '',
    color: '',
  },
}

export default class FilterTypeRegion extends ListFilterType {
  constructor(list) {
    super()
    this.list = FilterTypeRegion.formatList(list)
    this.default = DEFAULT_REGION
    this.list.unshift(this.default)
  }

  getDefault() {
    return this.default
  }

  static formatList(list) {
    return list.map(region => ({
      value: region.translit,
      name: region.name,
      data: {
        regionType: region.type,
        townRedirectTranslit: region.town_redirect_translit,
        color: region.color,
      },
    }))
  }

  static getAppliedName({ value, name }) {
    if (value === 'any') {
      return 'любой район'
    }

    return name
  }
}
